import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const Country = {
  id: 'country',
  displayName: <FormattedMessage {...messages.country} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'shipToCountryCode',
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER, criteriaInformations, existingFiltersHelpers);
  },
};
